import { styled } from '@mui/material'
import { useEffect, useState } from 'react'
import icon_BlueShield from 'src/assets/images/Icon_BlueShield.svg'
import icon_GreenSearch from 'src/assets/images/Icon_GreenSearch.svg'
import icon_OrangeMedaliion from 'src/assets/images/Icon_OrangeMedaliion.svg'
import icon_OrangeShield from 'src/assets/images/Icon_OrangeShield.svg'
import icon_PurpleSmile from 'src/assets/images/Icon_PurpleSmile.svg'
import { DataType } from './Stage_By_Rate'
import { Icon_Play } from '../common/CommonIcons'

const PageWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    gap:'7px',

    padding: '30px 20px 0px 20px',
    marginLeft: '25px'
}))

const DetailBoxWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'flex-start',
    flexDirection:'column',
    gap:'10px',

    borderRadius: '10px',
    background: '#F9F9F9',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.10)',
    width:'100%',
    height:'100%',
    padding:'10px 12px'
}))

const TitleWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    gap: '10px',

    whiteSpace:'nowrap'
}))

const TitleSpan = styled('span')(({theme})=>({
    fontWeight:'bold',
    flex:1
}))

const CountWrapper = styled('div')(({theme})=>({

}))

const CountContainer = styled('span')(({theme})=>({
    paddingRight:'8px',
    fontSize:'30px',
    fontWeight:'bold'
}))

const EndSpanWrapper = styled('span')(({theme})=>({
    fontSize:'11px',
    color:'#7C7C7C'
})) 

interface Props{
    propsdata : DataType[]
}

const Stage_By_RateDetail = ({propsdata}:Props) => {
    const [data,setData] = useState<DataType[]>(propsdata)
    const [attendData, setAttendData] = useState<DataType | null>(null)
    const [interestData, setInterestData] = useState<DataType | null>(null)
    const [prepareData, setPrepareData] = useState<DataType | null>(null)
    const [readyData, setReadyData] = useState<DataType | null>(null)
    const [deployData, setDeployData] = useState<DataType | null>(null)

    useEffect(()=>{
        setData(propsdata)
    },[propsdata])

    useEffect(()=>{
        if(data.length !== 0){
            setAttendData(data.find((item) => item.category === "참여") ?? null)
            setInterestData(data.find((item) => item.category === "관심") ?? null)
            setPrepareData(data.find((item) => item.category === "지원준비") ?? null)
            setReadyData(data.find((item) => item.category === "지원완료") ?? null)
            setDeployData(data.find((item) => item.category === "임관") ?? null)
        }
    },[data])


    return (
        <PageWrapper>
            <DetailBoxWrapper>
                <TitleWrapper>
                    <img src={icon_PurpleSmile}/>
                    <TitleSpan>1.홍보 행사 참여</TitleSpan>
                </TitleWrapper>
                <CountWrapper>
                    <CountContainer style={{paddingRight:'8px'}}>{attendData?.CurrentCount.toLocaleString()}</CountContainer>
                    <span>({attendData?.CurrentYear}%)</span>
                </CountWrapper>
                <EndSpanWrapper>인원 수 (전환율)</EndSpanWrapper>
            </DetailBoxWrapper>
            <Icon_Play/>
            <DetailBoxWrapper>
                <TitleWrapper>
                    <img src={icon_GreenSearch}/>
                    <TitleSpan>2.관심 표명</TitleSpan>
                    {/* <RateGap isPositive={interestGap}>
                        {
                        interestGap > 0 ? <img src={icon_ArrowUp}/> :
                        interestGap < 0 ? <img src={icon_ArrowDown}/> :
                        <span style={{paddingRight:'5px', fontWeight:'bold', fontSize:'18px'}}>-</span> // 같을 때
                        }
                        {interestGap}%</RateGap> */}
                </TitleWrapper>
                <CountWrapper>
                    <CountContainer style={{paddingRight:'8px'}}>{interestData?.CurrentCount.toLocaleString()}</CountContainer>
                    <span>({interestData?.CurrentYear}%)</span>
                </CountWrapper>
                <EndSpanWrapper>인원 수 (전환율)</EndSpanWrapper>
            </DetailBoxWrapper>
            <Icon_Play/>
            <DetailBoxWrapper>
                <TitleWrapper>
                    <img src={icon_OrangeShield}/>
                    <TitleSpan>3.지원 준비</TitleSpan>
                    {/* <RateGap isPositive={prepareGap}>                        {
                        prepareGap > 0 ? <img src={icon_ArrowUp}/> :
                        prepareGap < 0 ? <img src={icon_ArrowDown}/> :
                        <span style={{paddingRight:'5px', fontWeight:'bold', fontSize:'18px'}}>-</span> // 같을 때
                        }{prepareGap}%</RateGap> */}
                </TitleWrapper>
                <CountWrapper>
                    <CountContainer style={{paddingRight:'8px'}}>{prepareData?.CurrentCount.toLocaleString()}</CountContainer>
                    <span>({prepareData?.CurrentYear}%)</span>
                </CountWrapper>
                <EndSpanWrapper>인원 수 (전환율)</EndSpanWrapper>
            </DetailBoxWrapper>
            <Icon_Play/>
            <DetailBoxWrapper>
                <TitleWrapper>
                    <img src={icon_BlueShield}/>
                    <TitleSpan>4.지원 완료</TitleSpan>
                    {/* <RateGap isPositive={readyGap}>                        {
                        readyGap > 0 ? <img src={icon_ArrowUp}/> :
                        readyGap < 0 ? <img src={icon_ArrowDown}/> :
                        <span style={{paddingRight:'5px', fontWeight:'bold', fontSize:'18px'}}>-</span> // 같을 때
                        }{readyGap}%</RateGap> */}
                </TitleWrapper>
                <CountWrapper>
                    <CountContainer style={{paddingRight:'8px'}}>{readyData?.CurrentCount.toLocaleString()}</CountContainer>
                    <span>({readyData?.CurrentYear}%)</span>
                </CountWrapper>
                <EndSpanWrapper>인원 수 (전환율)</EndSpanWrapper>
            </DetailBoxWrapper>
            <Icon_Play/>
            <DetailBoxWrapper>
                <TitleWrapper>
                    <img src={icon_OrangeMedaliion}/>
                    <TitleSpan>5.임관</TitleSpan>
                    {/* <RateGap isPositive={deployGap}>                        {
                        deployGap > 0 ? <img src={icon_ArrowUp}/> :
                        deployGap < 0 ? <img src={icon_ArrowDown}/> :
                        <span style={{paddingRight:'5px', fontWeight:'bold', fontSize:'18px'}}>-</span> // 같을 때
                        }{deployGap}%</RateGap> */}
                </TitleWrapper>
                <CountWrapper>
                    <CountContainer style={{paddingRight:'8px'}}>{deployData?.CurrentCount.toLocaleString()}</CountContainer>
                    <span>({deployData?.CurrentYear}%)</span>
                </CountWrapper>
                <EndSpanWrapper>인원 수 (전환율)</EndSpanWrapper>
            </DetailBoxWrapper>
        </PageWrapper>
    )
}

export default Stage_By_RateDetail